function gst(state = [], action) {
  switch (action.type) {
    case 'SET_GST_CART_DETAILS':
      const updatedGstCartDetails = { ...action.gstCartDetails };
      if (
        state?.gstCartDetails?.gstNumber &&
        state?.gstCartDetails?.gstNumber !== updatedGstCartDetails?.gstNumber
      ) {
        updatedGstCartDetails.isVerified = false;
      }
      console.log('🚀 gst reducer state update ', {
        gstCartDetails: {
          ...state.gstCartDetails,
          ...updatedGstCartDetails
        }
      })
      return {
        ...state,
        gstCartDetails: {
          ...state.gstCartDetails,
          ...updatedGstCartDetails
        }
      };
    case 'SET_GST_SAVED_PROFILES':
      return { ...state, gstProfiles: action.gstSavedProfiles };
    default:
      return state;
  }
}

export default gst;
